import PercentSVG from './svgs/percent.svg'

export {PercentSVG};